var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-clear-refinements',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var refine = ref.refine;
return [_c('button',{staticClass:"ais-ClearRefinements-button",on:{"click":function($event){return _vm.resetFilters(refine)}}},[_vm._v("\n      "+_vm._s(_vm.$t('Clear filters'))+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }